import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props, { expose: __expose }) {
  __expose();

const position = ref("top-right");
 


const __returned__ = { position }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})